import React, { FC, useContext } from 'react';
import { NavContext } from './NavContext';
import { Branding } from './SideNavTypes';

export const BrandingLogo: FC<Branding> = ({ logo, invertedLogo, label, href, ariaLabel }) => {
  const context = useContext(NavContext);

  return (
    <div
      className={`branding-logo ${context.mobileToggle ? 'inverted' : ''}`}
      aria-label={ariaLabel ? ariaLabel : label}>
      {href ? (
        <a href={href} aria-label={ariaLabel ? ariaLabel : label}>
          {' '}
          <img
            src={context.mobileToggle ? logo : invertedLogo}
            alt={ariaLabel ? ariaLabel : label}
            aria-hidden="true"
          />
        </a>
      ) : (
        <img src={context.mobileToggle ? logo : invertedLogo} alt={ariaLabel ? ariaLabel : label} aria-hidden="true" />
      )}
    </div>
  );
};
BrandingLogo.displayName = 'BrandingLogo';
export default BrandingLogo;
